import { LoginCredentials, RegisterData, User, AuthToken } from '@shared/types';
import { apiClient } from './apiClient';

class AuthService {
  async login(credentials: LoginCredentials): Promise<{ user: User; auth: AuthToken }> {
    const response = await apiClient.post('/auth/login', credentials);
    return response.data;
  }

  async register(data: RegisterData): Promise<{ user: User }> {
    const response = await apiClient.post('/auth/register', data);
    return response.data;
  }

  async getCurrentUser(): Promise<User> {
    const response = await apiClient.get('/users/me');
    return response.data.user;
  }

  async refreshToken(refreshToken: string): Promise<{ accessToken: string }> {
    const response = await apiClient.post('/auth/refresh', { refreshToken });
    return response.data;
  }
}

export const authService = new AuthService();